module.exports = __webpack_public_path__ + "img/rimg01.db6b289f.png";